<template>
  <div class="pt-2 secondary">
    <div class="text-h6 text-center mb-2">{{ groupName }} | {{ itemName }}</div>

    <v-text-field
      label="Τίτλος"
      color="primary"
      dense
      outlined
      hide-details
      dark
      class="mb-2"
    ></v-text-field>

    <v-textarea
      dense
      outlined
      hide-details
      dark
      color="primary"
      class="mb-4"
      no-resize
      label="Περιγραφή"
    ></v-textarea>

    <v-btn small depressed color="primary" @click="addQuestion"
      >Add Question</v-btn
    >

    <QuizQuestion
      v-for="(question, index) in questions"
      :key="question.id"
      :question="question"
      :index="index"
      @deleteQuestion="deleteQuestion"
      @addAnswer="addAnswer"
      @deleteAnswer="deleteAnswer"
      @questionInput="questionInput"
      @answerInput="answerInput"
      @correctAnswer="correctAnswer"
    />
  </div>
</template>

<script>
import QuizQuestion from "@/components/QuizQuestion.vue";
import { nanoid } from "nanoid";

export default {
  props: ["groupName", "itemName"],
  components: {
    QuizQuestion,
  },
  data() {
    return {
      questions: [
        {
          id: nanoid(),
          question: "",
          answers: [],
        },
      ],
    };
  },
  methods: {
    addQuestion() {
      this.questions.push({
        id: nanoid(),
        question: "",
        answers: [],
      });
    },
    deleteQuestion(id) {
      this.questions = this.questions.filter((q) => q.id != id);
    },
    addAnswer(questionId) {
      const found = this.questions.find((q) => q.id == questionId);

      if (!found) return;

      found.answers.push({
        id: nanoid(),
        answer: "",
        isCorrect: false,
      });
    },
    deleteAnswer(questionId, answerId) {
      const foundQuestion = this.questions.find((q) => q.id == questionId);

      if (!foundQuestion) return;

      foundQuestion.answers = foundQuestion.answers.filter(
        (a) => a.id != answerId
      );
    },
    questionInput(questionId, input) {
      const foundQuestion = this.questions.find((q) => q.id == questionId);

      if (!foundQuestion) return;

      foundQuestion.question = input;
    },
    answerInput(questionId, answerId, input) {
      const foundQuestion = this.questions.find((q) => q.id == questionId);

      if (!foundQuestion) return;

      const foundAnswer = foundQuestion.answers.find((a) => a.id == answerId);

      foundAnswer.answer = input;
    },
    correctAnswer(questionId, answerId, checkbox) {
      const foundQuestion = this.questions.find((q) => q.id == questionId);

      if (!foundQuestion) return;

      foundQuestion.answers = foundQuestion.answers.map((a) => {
        return {
          ...a,
          isCorrect: a.id == answerId ? checkbox : false,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>